import React from 'react';
import {eventMomentFactory} from '../../../../../data/misc/eventMomentFactory';
import eventHumanFriendlyDate from '../../../../../misc/eventHumanFriendlyDate';
import ListItem from '../../../../elements/DEPRECATED_ListItem';

/**
 * Event Time and Date component
 * @param {object} props
 * @returns React.Component
 */

const EventDateAndTime = props => {
    const {event, start: startTimestamp, end: endTimestamp} = props,
        start = eventMomentFactory(event, startTimestamp || event.start_utc);

    return (
        <ListItem tagName="div" icon="img/calendar_icon_small.png" iconColor="#a9a9a9">
            <p
                className="text main text-upper"
                style={{
                    color: 'black',
                }}>
                <b>{eventHumanFriendlyDate(event, startTimestamp || event.start_utc, endTimestamp || startTimestamp || event.end_utc)}</b>
            </p>
            <p className="text text-upper">
                {start.format('dddd')} {start.format('LT')}
            </p>
        </ListItem>
    );
};

export default EventDateAndTime;
